<template>
    <header class="tw:shadow-sm tw:fixed tw:top-0 tw:inset-x-0 tw:z-50 tw:bg-[#353A41]">
        <div class="tw:mx-auto tw:px-4 tw:sm:px-6 tw:lg:px-8">
            <div class="tw:flex tw:justify-between tw:h-16">
                <div class="tw:flex" />
                <div class="tw:flex tw:items-center tw:space-x-8 tw:ml-6">
                    <UserMenu />
                    <BenachrichtigungNavBarMenu />
                    <InsightMenu />
                </div>
            </div>
        </div>
    </header>
    <NotificationContainer class="tw:top-16 tw:z-10" />
</template>

<script setup lang="ts">
import BenachrichtigungNavBarMenu from "./BenachrichtigungMenu.vue";
import InsightMenu from "./InsightMenu.vue";
import NotificationContainer from "../common/notifications/NotificationContainer.vue";
import UserMenu from "./UserMenu.vue";
</script>
